<template>
    <div class="line-container">
        <svg :height="height" width="100%" class="progress-bar">
            <line x1="0" y1="0" x2="100%" y2="0" :style="LineStylesBg" class="line-background"/>
        </svg>
        
        <svg :height="height" :width="getProgress" class="progress-bar">
            <line x1="0" y1="0" x2="100%" y2="0" :style="LineStyles" class="line-progress"/>
            <!-- Sorry, your browser does not support inline SVG. -->
        </svg>
    </div>
</template>

<script>
import * as JSFunction from "../Functions/Functions.js"

export default {
    name: "SProgressLinear",

    components: {
    
    },

    props:{
        
        height:{
            Type:Number,
            default: 1
        },

        progress:{
            Type: String,
            default: '22%'
        },

        color:{
            Type: String,
            default:"var(--primary)"
        },

        background:{
            Type:String,
            default:"var(--very-light-pink)"
        }
    },

    data() {
        return {
            id:null,

        };
    },

    methods: {

    },

    created() {
        this.id = "line#"+JSFunction.uuid();
    },

    validations: function() {
        return {

        };
    },

    computed: {
        // ComputeWidth(){},
        LineStyles(){
            return{
                'stroke':this.color,
                'stroke-width':this.height
            }
        },

        LineStylesBg(){
            return{
                'stroke':this.background,
                'stroke-width':this.height
            }
        },

        getProgress(){
            
            let result = parseFloat(this.progress);
            if(result<0){
                
                result = 0.0;

            }else if(result>100){

                result = 100.0;

            }
            return result+"%";
        }
    }

};
</script>

<style lang="scss" scoped>
.line-container{
    width: 100%;
    position: relative;
}
.progress-bar{
    position: absolute;
}
.line-background{
    z-index: 1;
}

.line-progress{
    z-index: 2;
}
</style>